import { styled } from "../../../styles";

/** Edition chips on the right of the page title — one per seeded edition. */
export const SummaryRow = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "8px",
});

/**
 * "BE 4": the edition code and its row count. Everything else about the
 * edition (active / retired split, rows per semantic tag) is in the chip's
 * tooltip, so the header stays one line tall.
 */
export const EditionChip = styled("span", {
  display: "inline-flex",
  alignItems: "baseline",
  gap: "6px",
  padding: "4px 10px",
  borderRadius: "16px",
  border: "1px solid $gray-30",
  backgroundColor: "$white",
  fontSize: "13px",
  lineHeight: "18px",
  color: "$gray-80",
  cursor: "default",
  whiteSpace: "nowrap",
});

export const EditionCode = styled("span", {
  fontWeight: "600",
  color: "$gray-100",
});

export const EditionVersion = styled("span", {
  color: "$gray-60",
});

/** Tooltip body: one line per fact, no bullets. */
export const EditionTooltip = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  fontSize: "12px",
  lineHeight: "16px",
});

export const EditionTooltipTitle = styled("span", {
  fontWeight: "600",
  marginBottom: "2px",
});
